import { v4 as uuidv4 } from 'uuid'
import { Timezone } from '../types/common'

export function NotYetImplemented<T> (): T {
  throw new Error('Not yet implemented')
}

export const uuid = (): string => {
  return uuidv4()
}

export const parseTimezone = (timezone: string): Timezone => {
  switch (timezone) {
    case 'NEW_YORK':
    case 'EST':
      return Timezone.NEW_YORK
    case 'CHICAGO':
      return Timezone.CHICAGO
    case 'DENVER':
      return Timezone.DENVER
    case 'LOS_ANGELES':
      return Timezone.LOS_ANGELES
    default:
      throw new Error(`Invalid timezone: ${timezone}`)
  }
}
